var Conseiller = /** @class */ (function () {
    function Conseiller() {
    }
    return Conseiller;
}());
export { Conseiller };
